import React from 'react'

import { NavigationEditor } from 'features/navigation/NavigationEditor/NavigationEditor'

export default function AppModalNavigation() {
    return <NavigationEditor />
}
